export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9482.009808f7.jpg";